module.exports = __webpack_public_path__ + "804b063331b8a1e33add53950cb81182.svg";